import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  Checkbox,
  TextField,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState, forwardRef, useRef } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { NavLink } from "react-router-dom";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import ReactToPrint from "react-to-print";
import {
  editDeleteScheduleEntry,
  getScheduleEntryList,
  addScheduleEntry,
} from "../../../actions/actions"; //addScheduleEntry
import CloseIcon from "@mui/icons-material/Close"; // Import CloseIcon



const ComponentToPrintWrapper = ({ quotationPrint }) => {
  const ref = useRef();
  return (
    <div style={{ display: "flex" }}>
      <ReactToPrint
        trigger={() => (
          <span style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <PrintOutlinedIcon />{" "}
            <span style={{ marginLeft: "22px" }}> Print Record </span>{" "}
          </span>
        )}
        content={() => ref.current}
      />
    </div>
  );
};

const ViewScheduleList = (props) => {
  const dispatch = useDispatch();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [selectedRows, setSelectedRows] = useState({});
  const [plannedValues, setPlannedValues] = useState({});

  const rows = useSelector((state) => state.schedule_entry.schedule_entry);

  const [searchKey, setSearchKey] = useState("");

  const fields = [
    "customer",
    "so_no",
    "issued_by",
    "approved_by",
    "delivery_by",
    "total_credit_limit",
    "gross_amount",
  ];

  const labels = [
    "Customer",
    "Sales Order No",
    "Issued By",
    "Approved By",
    "Delivery By",
    "Total Credit Limit",
    "Gross Amount",
  ];

  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = "test";
  const [total_count, setTotalCount] = useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 999,
  });

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = () => {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
    };
    dispatch(getScheduleEntryList(params));
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const params = {
      page: controller.page,
      size:
        e.target.value === ""
          ? controller.rowsPerPage
          : rows[0]?.total_count || 0,
      searchKey: e.target.value,
    };
    dispatch(getScheduleEntryList(params));
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const { shouldShowMsg, responseMessage } = useMessageHandler(
    null,
    setSuccessMessage,
    respMsgState
  );

  useEffect(() => { }, [shouldShowMsg, responseMessage]);

  const deleteRecord = (id) => {
    dispatch(
      editDeleteScheduleEntry({
        schedule_id: id,
        changedUpdatedValue: "delete",
      })
    );
    setIsDelete(false);
    fetchData();
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleCheckboxChange = (rowId) => {
    setSelectedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const handleInputChange = (rowId, value) => {
    setPlannedValues((prev) => ({
      ...prev,
      [rowId]: value,
    }));
  };

  const handleSubmit = () => {
    const selectedRecords = rows.flatMap((row) => {
      // Parse schedule_details for each row
      const scheduleDetails = Array.isArray(JSON.parse(row.schedule_details))
        ? JSON.parse(row.schedule_details)
        : [];

      // Filter and map over the scheduleDetails array
      return scheduleDetails
        .filter(
          (detail, detailIndex) => selectedRows[`${row.so_no}-${detailIndex}`]
        )
        .map((detail) => ({
          sr_no: detail.srno || row.sr_no,
          customer_name: row.customer_name,
          schedule_no: row.schedule_no,
          schedule_date: row.schedule_date,
          product_code: detail.product || row.product_code,
          product_description:
            detail.prod_description || row.product_description,
          cyl_code: detail.cyl_code || row.cyl_code,
          schedule_quantity: detail.soqty || row.schedule_quantity,
          uom: detail.uom || row.uom,
          del_qty: detail.del_qty || row.del_qty,
          bal_qty: detail.bal_qty || row.bal_qty,
          empty_cyl_avl: detail.empty_cyl_avl || row.empty_cyl_avl,
          plan_quantity: detail.plan_quantity || row.plan_quantity,
          unit: detail.unit || row.unit,
        }));
    });

    console.log("Selected Records of schedule list:", selectedRecords);
    props.onSelectRecords(selectedRecords); // Send all necessary fields
    fetchData();
  };

  const handleCancel = () => {
    setSelectedRows({});
    setPlannedValues({});
  };

  console.log("data", rows);
  return (
    <>
      <Paper className={`${styles.cts_page}`}>
        {/* <Breadcrumb
                    routeSegments={[
                        { name: 'View Schedule And Plan' },
                    ]}
                /> */}
        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.form_title}`}>
                  View Schedule Entry
                </Typography>
                {/* <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton> */}
              </Box>
            </Grid>
            <Grid
              item
              md={5}
              sm={6}
              xs={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {/* <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="View Schedule Entry"
                                />
                            </Box> */}
              <SearchInput value={searchKey} onChange={handleSearch} />
              {/* <AddButton to="/productionEntries/add-se" label="" /> */}
            </Grid>
          </Grid>
        </Box>
        <TableContainer
          component={Paper}
          className={`${styles.list_tbl_container}`}
          style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }} // Set max height and enable scrolling
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  Action
                </StyledTableCell>
                <StyledTableCell
                  align="Left"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("customer_name", sortBy, setSortBy, rows)
                  }
                >
                  Customer Name
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "custome_name" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("schedule_no", sortBy, setSortBy, rows)
                  }
                >
                  Schedule No
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "schedule_no" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  Product Code
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  cyl_code
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  Schedule Quantity
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  UOM
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  App No Cyl
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  Avl Empty Cyl
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(rows) &&
                rows.map(
                  (row, index) =>
                    Array.isArray(JSON.parse(row.schedule_details)) &&
                    JSON.parse(row.schedule_details).map(
                      (detail, detailIndex) => (
                        <StyledTableRow
                          key={`${row.so_no}-${detailIndex}`}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <StyledTableCell align="center">
                            <Checkbox
                              checked={
                                !!selectedRows[`${row.so_no}-${detailIndex}`]
                              }
                              onChange={() =>
                                handleCheckboxChange(
                                  `${row.so_no}-${detailIndex}`
                                )
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            className={`${styles.list_table_body}`}
                          >
                            <NavLink
                              to="/productionEntries/details-se"
                              state={row}
                              className={`${styles.underline}`}
                              style={{ color: "blue", cursor: "pointer" }}
                            >
                              {row.customer_name}
                            </NavLink>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {row.schedule_no}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {detail.product}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {detail.cyl_code}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {detail.soqty}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {detail.uom}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {detail.approved_cyl}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {"0"}
                          </StyledTableCell>
                          {/* <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                                            {selectedRows[`${row.so_no}-${detailIndex}`] ? (
                                                <TextField
                                                    size="small"
                                                    value={plannedValues[`${row.so_no}-${detailIndex}`] || ''}
                                                    onChange={(e) => handleInputChange(`${row.so_no}-${detailIndex}`, e.target.value)}
                                                />
                                            ) : (
                                                detail.planned_no_of_cyl || ''
                                            )}
                                        </StyledTableCell> */}
                        </StyledTableRow>
                      )
                    )
                )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          component="div"
          onPageChange={handleChangePage}
          page={controller.page}
          count={rows && (rows[0]?.total_count || 0)}
          rowsPerPage={controller.rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.schedule_id || null}
          displayName={deleteInfo?.schedule_id || ""}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ mr: 2 }}
          >
            Submit
          </Button>
          <Button variant="contained" color="secondary" onClick={handleCancel}>
            Clear
          </Button>
        </Box>
      </Paper>
    </>
  );
};
export default ViewScheduleList;
